module.exports = __webpack_public_path__ + "static/media/backbone.4c8f80dd.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Portfolio/images/platforms/backbone.png
 ** module id = 212
 ** module chunks = 0
 **/